import React, { useState } from 'react';
import cc from 'classcat';

interface IOptions {
    options: IOptionItem[];
    className?: string;
    optionsMenuClassName?: string;
}

export interface IOptionItem {
    label: string;
    color?: OptionColors;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
}

type OptionColors = 'success' | 'error';

export const Options = ({ options, className, optionsMenuClassName }: IOptions) => {
    const [menuVisible, setMenuVisible] = useState(false);

    return (
        <>
            <div className={cc(['options', className])}>
                <button onClick={() => setMenuVisible(prev => !prev)} className={cc(['options__button', { 'options__button--active': menuVisible }])}>
                    <img src={menuVisible ? '/svg/3dots.svg' : '/svg/3dots-black.svg'} alt="Three dots" />
                </button>

                {menuVisible && (
                    <>
                        <div className={cc(['options__menu', optionsMenuClassName])}>
                            {options.map(item => (
                                <button
                                    className={cc(['options__item', item.color && `options__item--${item.color}`, 'paragraph-4'])}
                                    key={item.label}
                                    onClick={e => {
                                        setMenuVisible(false);
                                        item.onClick(e);
                                    }}
                                >
                                    {item.label}
                                </button>
                            ))}
                            <div onClick={() => setMenuVisible(false)} className="opt-bubble-mask"></div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};
